// src/components/AccountSidebar.jsx
import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';

const AccountSidebar = () => {
    const navigate = useNavigate();
    const location = useLocation();

    // Define your menu items and their routes here
    const menuItems = [
        { label: "My Profile", path: "/myprofile" }, // Update '/my-profile' to your actual route path
        { label: "Rolling Commission", path: "/rolling-commission" },
        { label: "Account Statement", path: "/account-statement" },
        { label: "My Bets", path: "/bet-history" },
        { label: "Activity Log", path: "/activity-log" }
    ];

    return (
        <div className="w-full lg:w-[220px] bg-white border border-gray-300 rounded shadow-sm flex-shrink-0 hidden lg:block">
            <div className="bg-black text-white text-right px-3 py-1 text-[12px] font-normal">
                My Account
            </div>
            <ul className="text-[12px]">
                {menuItems.map((item, index) => {
                    // Check if this item is the current page
                    const isActive = location.pathname === item.path;

                    return (
                        <li
                            key={index}
                            onClick={() => navigate(item.path)}
                            className={`px-3 py-1 border-b cursor-pointer transition-colors duration-200 
                                ${isActive
                                    ? "bg-[#555] text-white border-gray-600" // Active Style
                                    : "border-gray-200 text-gray-700 hover:bg-gray-100" // Inactive Style
                                }`}
                        >
                            {item.label}
                        </li>
                    );
                })}
            </ul>
        </div>
    );
};

export default AccountSidebar;